import React from "react";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const WhatsAppButton = ({ 
  phoneNumber = "56997034800", 
  message = "",
  position = { bottom: 24, right: 24 },
  size = "large" // "small", "medium", "large"
}) => {
  const url = message 
    ? `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`
    : `https://wa.me/${phoneNumber}`;

  const sizeConfig = {
    small: { button: "w-12 h-12", icon: 24 },
    medium: { button: "w-16 h-16", icon: 28 },
    large: { button: "w-20 h-20", icon: 32 },
  };

  const { button, icon } = sizeConfig[size] || sizeConfig.large;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={`fixed z-50 flex items-center drop-shadow-lg shadow-md justify-center ${button} rounded-full shadow-lg transition-all duration-300 hover:scale-110 hover:shadow-2xl`}
      style={{
        backgroundColor: "#25D366",
        bottom: position.bottom,
        right: position.right,
        boxShadow: "0 4px 15px rgba(37, 211, 102, 0.4)",
      }}
      aria-label="Contact us on WhatsApp"
    >
      <WhatsAppIcon sx={{ fontSize: icon, color: "#fff", transform:"translateY(-1px)" }} />
    </a>
  );
};

export default WhatsAppButton;